import {
  addUserData,
  addUserWithClientId,
  getRolesData,
  getUserData,
  getUsersWithClientId,
  searchUser,
  searchUsersWithClientId,
  setPageNumber,
  setRowsPerPage,
  updateUserData,
} from "../../store/user";
import useEntityList from "./useEntityList";

const USER_ACTIONS = {
  getUserDataAction: getUserData,
  setRowsPerPageAction: setRowsPerPage,
  setPageNumberAction: setPageNumber,
  addUserDataAction: addUserData,
  updateUserDataAction: updateUserData,
  searchUserDataAction: searchUser,
  rolesDataAction: getRolesData,
  getUsersWithClientAction: getUsersWithClientId,
  addUsersWithClientAction: addUserWithClientId,
  searchUserWithClientAction: searchUsersWithClientId,
};

const selectUserExtras = (users) => ({
  roles: users?.userRoles ?? null,
});

function useUser() {
  return useEntityList({
    stateKey: "users",
    listKey: "userList",
    actionCreators: USER_ACTIONS,
    selectExtras: selectUserExtras,
  });
}

export default useUser;
